/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SourcingSearchProfileAvailability = {
    AvailableAndVerified: 'AVAILABLE_AND_VERIFIED',
    Available: 'AVAILABLE',
    AvailableSoon: 'AVAILABLE_SOON',
    NotAvailableWithDate: 'NOT_AVAILABLE_WITH_DATE',
    NotAvailable: 'NOT_AVAILABLE'
} as const;
export type SourcingSearchProfileAvailability = typeof SourcingSearchProfileAvailability[keyof typeof SourcingSearchProfileAvailability];


export function instanceOfSourcingSearchProfileAvailability(value: any): boolean {
    for (const key in SourcingSearchProfileAvailability) {
        if (Object.prototype.hasOwnProperty.call(SourcingSearchProfileAvailability, key)) {
            // @ts-ignore
            if (SourcingSearchProfileAvailability[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SourcingSearchProfileAvailabilityFromJSON(json: any): SourcingSearchProfileAvailability {
    return SourcingSearchProfileAvailabilityFromJSONTyped(json, false);
}

export function SourcingSearchProfileAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchProfileAvailability {
    return json as SourcingSearchProfileAvailability;
}

export function SourcingSearchProfileAvailabilityToJSON(value?: SourcingSearchProfileAvailability | null): any {
    return value as any;
}

